'use strict';
import angular from 'angular';
import $ from 'jquery';

import widgetChartHtmlUrl from '../widget.chart.html';

angular.module('widget.slicechart.directives', [])

    .directive('slicechartWidget', slicechartWidget);

/**
 * @ngInject
 */
function slicechartWidget() {
    return {
        restrict: 'E',
        templateUrl: widgetChartHtmlUrl,
        controller: 'SliceChartWidgetController',
        scope: {
            state: '=',
            widget: '=',
            chartId: '<',
            widgetTypeId: '<',
            widgetIsPredefined: '<'
        }
    }
}